import React from 'react'
import dayjs from 'dayjs'

import {
    EditOutlined,
    DeleteOutlined,
    CheckCircleOutlined,
} from '@ant-design/icons'

import { Item } from '../../Item'
import { StyledButton } from '../../Button'

import { useCaseViewContext } from '../../../context'

import {
    ProviderNoteItem,
    ProviderNoteTitle,
    ProviderNoteContent,
    ProviderNoteFooter
} from './ProviderNote.styles'

import {
    ButtonGroup
} from './ChartingEntry.styles'

export const ProviderNote = ({
    item,
    onSelect,
    onEdit,
    onDelete,
}) => {
    const { provider, apiType, fetchCaseDetails, physicianDetails, caseDetails } = useCaseViewContext()
    
    const isAuthor = provider?.userId === item.createdBy?._id || 
                     provider?.userId === item.createdBy ||
                     provider?._id === item.createdBy?._id ||
                     provider?._id === item.createdBy

    const isRejectionReasonNote = item.title?.toLowerCase() === 'reject reason'
    const isReviewNotesNote = item.title?.toLowerCase() === 'review notes'
    const needsConfirmation = item.needsConfirmationBy?.includes(physicianDetails.userId) && !item.confirmedBy.includes(physicianDetails.userId)
    
    const canEdit = isAuthor && apiType !== 'admin'
    
    const handleDeleteProviderNote = () => {
        onDelete(item)
    }

    const handleSelectProviderNote = () => {
        onSelect(item)
    }

    const handleConfirm = async () => {
        await onEdit({ _id: item._id, confirmed: true })
        fetchCaseDetails(caseDetails?._id)
    }

    const renderTimestamp = item => {
        return item.updatedDate && item.updatedDate !== 'N/A' ? dayjs(new Date(item.updatedDate)).format('MM/DD/YYYY h:mm A') : dayjs(new Date(item.createdDate)).format('MM/DD/YYYY h:mm A')
    }

    return (
        <Item
            key={item._id}
            label={renderTimestamp(item)}
            value={ 
                <ProviderNoteItem>
                    <ProviderNoteTitle>{item.title}</ProviderNoteTitle>
                    <ProviderNoteContent>{item.content}</ProviderNoteContent>
                    <ProviderNoteFooter>
                        <strong>{item.authorName || 'Provider'}</strong>
                        { 
                            isReviewNotesNote && needsConfirmation && (
                                <StyledButton
                                    Icon={CheckCircleOutlined}
                                    text="OK"
                                    key="confirm-button"
                                    note={item}
                                    onClick={handleConfirm}
                                />
                            )
                        }
                        {canEdit && !isRejectionReasonNote && !isReviewNotesNote && (
                            <ButtonGroup>
                                <StyledButton
                                    type="button"
                                    size="small"
                                    color="red"
                                    Icon={DeleteOutlined}
                                    onClick={handleDeleteProviderNote}
                                />
                                <StyledButton
                                    type="button"
                                    size="small"
                                    Icon={EditOutlined}
                                    onClick={handleSelectProviderNote}
                                />
                            </ButtonGroup>
                        )}
                    </ProviderNoteFooter>
                </ProviderNoteItem>
            }
        />
    )
}
